import { useEffect, useState } from 'react';
import { Button, FloatingLabel, Form } from 'react-bootstrap';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import EcomEngineAPI from 'api/ecom_engine_api';
import { trackError } from 'utils/helpers';
import CardSkeleton from '../card-skeleton';
import { Card } from './card';

const APIs = {
  'special offers': EcomEngineAPI.entry.getSpecialOffers,
  events: EcomEngineAPI.entry.getEvents,
};

const CardsFilter = ({ filter, type = 'special offers' }) => {
  const [cardsData, setCardsData] = useState([]);
  const [status, setStatus] = useState('idle');
  const [siteHandle, setSiteHandle] = useState('');

  useEffect(() => {
    setCardsData([]);
    setStatus('loading');

    APIs[type]({ site: siteHandle })
      .then((res) => {
        setCardsData(res);
        setStatus('succeed');
      })
      .catch((error) => {
        trackError(error);
        setStatus('failed');
      });
  }, [siteHandle, type]);

  return (
    <div>
      {/* Filters */}
      <div className="row justify-content-center mb-5">
        <div className="col col-md-4 col-lg-3" key={filter.title}>
          <FloatingLabel controlId={filter.title} label={filter.title}>
            <Form.Select
              aria-label={filter.title}
              value={siteHandle}
              onChange={(e) => setSiteHandle(e.target.value)}
            >
              <option value="">Viewing All</option>
              {filter.options.map((option) => (
                <option value={option.handle} key={option.handle}>
                  {option.site}
                </option>
              ))}
            </Form.Select>
          </FloatingLabel>
        </div>
      </div>

      {/* Cards */}
      <ul className="row gy-5">
        {status === 'succeed' &&
          cardsData.map((entry) => (
            <li className="col-12 col-sm-6 col-md-4" key={entry.url}>
              {/* eslint-disable-next-line react/jsx-props-no-spreading */}
              <Card {...entry} />
            </li>
          ))}

        {status === 'loading' &&
          [...Array(6)].map((e, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <div className="col-12 col-sm-6 col-md-4" key={index}>
              <CardSkeleton />
            </div>
          ))}
      </ul>

      {/* Empty state */}
      {status === 'succeed' && isEmpty(cardsData) && (
        <div className="d-flex flex-column align-items-center gap-3 mt-5">
          <p className="fw-bold text-x-large">
            Sorry, no {type} found
            {siteHandle !== '' && (
              <>
                {' '}
                for{' '}
                {
                  filter.options.find((option) => option.handle === siteHandle)
                    ?.site
                }
              </>
            )}
          </p>
          <p>Try adjusting your filter to find other {type}</p>
          <Button variant="outline-primary" onClick={() => setSiteHandle('')}>
            Reset filter
          </Button>
        </div>
      )}
    </div>
  );
};

export { CardsFilter };

CardsFilter.propTypes = {
  filter: PropTypes.shape({
    title: PropTypes.string,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        site: PropTypes.string,
        handle: PropTypes.string,
      })
    ),
  }),
  type: PropTypes.string,
};
